<template>
    <div id="app">
        <homePage/>
    </div>
</template>

<script>
import homePage from '@/views/homePage/homePage.vue'

export default {
    components: {homePage},
    name: 'App',
}
</script>

<style lang="scss" scoped>
@import "styles/icons/iconfont.css";


#app {
    height: calc(100vh - 0px);
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

.iconSymbol {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}
</style>

